import { render } from "./Fota.vue?vue&type=template&id=d0e42e34&scoped=true"
import script from "./Fota.vue?vue&type=script&lang=js"
export * from "./Fota.vue?vue&type=script&lang=js"

import "./Fota.vue?vue&type=style&index=0&id=d0e42e34&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e42e34"]])

export default __exports__